import * as React from "react";
import "../theme/components/SuccessPopUp.scss";


type TickMessageProps = {
    onClose: () => void;
};

export default class PopUpTickMessage extends React.Component<TickMessageProps> {

    public render() {
        const { onClose } = this.props;

        return (
            <div className="popup-message-overlay">
                <div className="popup-message-box">
                    <span className="popup-icon" aria-label="Success">Success</span>
                    <span>Promotion eligibility successfully registered!</span>
                    <button className="close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        );
    }
}
